import { useContext, useEffect } from 'react';
import { FavoriteProductListContext } from 'Context/FavoriteProductListContext';

// Transform it to a hook after BookingEngine migration to functional component
export const TravelPlansComponent = ({ savedProposal, selectedProposal, resort, setFavorite }) => {
  const {
    favoriteProductsState: { favoriteProductList },
    addTravelPlan,
  } = useContext(FavoriteProductListContext);

  useEffect(() => {
    setFavorite(favoriteProductList.some(({ reference }) => reference === selectedProposal.id));
  }, [selectedProposal]);

  useEffect(() => {
    if (savedProposal) {
      addTravelPlan(savedProposal, resort);
    }
  }, [savedProposal]);
  return null;
};
